import Type from "@actionTypes";
/**
 * menuInfo reducer
 * @param {*} state
 * @param {*} action
 */
export const menuInfo = (
  state = {
    isShowMenu: true,
    openKeys: [],
    selectedKeys: [],
    tabsList: [],
    activeKey: "",
    activeTab: {},
  },
  action
) => {
  switch (action.type) {
    case Type.MENU_CHANGE:
      return {
        ...state,
        isShowMenu: !state.isShowMenu,
      };
    // 点击菜单 or 切换tab
    case Type.MENU_CLICK:
    {
      const activeKey = action.child.key;
      const { tabsList = [] } = state;
      const keyList = tabsList.map(i => i.key);
      if (keyList.includes(activeKey)) {
        return {
          ...state,
          activeKey,
          activeTab: action.child
        };
      } else {
        let newlist = [...tabsList]
        if(newlist.length > 7){
          newlist = newlist.slice(1)
        }
        newlist.push(action.child)
        return {
          ...state,
          tabsList: newlist,
          activeKey,
          activeTab: action.child
        };
      }
    }
    // 关闭tab
    case Type.SPLICE_TABSLIST:
    {
      return {
        ...state,
        ...action.param
      }
      // const { activeKey, tabsList = [] } = state;
      // const keyList = tabsList.map(i => i.key);
      // if (activeKey === action.key) {
      //   const keyIndex = keyList.indexOf(activeKey)
      //   return {
      //     ...state,
      //     ...action.param
      //     tabsList: tabsList.filter(tab => tab.key !== action.key),
      //     activeKey: keyList[keyIndex-1 > 0 ? keyIndex-1 : 0],
      //     activeTab: tabsList[keyIndex-1 > 0 ? keyIndex-1 : 0]
      //   };
      // }
      // return {
      //   ...state,
      //   tabsList: tabsList.filter(tab => tab.key !== action.key),
      // };
    }
    case Type.CLEAR_MENU:
      return {
        isShowMenu: true,
        openKeys: [],
        selectedKeys: [],
        tabsList: [],
        activeKey: "",
        activeTab: {},
      };
    case Type.CHANGE_ACTIVE_URL:
      const newList = state.tabsList.map(i=>{
        if (i.key === state.activeKey) {
          i.url = action.url
        }
        return i
      })
      return {
        ...state,
        activeTab: {
          ...state.activeTab,
          url: action.url,
        },
        tabsList: newList
      };
    case Type.CHANGE_ALL_URL:
      const allList = state.tabsList.map(i=>{
        if (i.url === '/fagicCourt/detail/mediation') {
          i.url = action.url
        }
        return i
      })
      return {
        ...state,
        activeTab: {
          ...state.activeTab,
          url: action.url,
        },
        tabsList: allList
      };
    default:
      return state;
  }
};
